import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as styles from './WhiteLabelPreview.scss';

var WhiteLabelPreview = /*#__PURE__*/function (_Component) {
  _inherits(WhiteLabelPreview, _Component);

  var _super = _createSuper(WhiteLabelPreview);

  function WhiteLabelPreview() {
    _classCallCheck(this, WhiteLabelPreview);

    return _super.apply(this, arguments);
  }

  _createClass(WhiteLabelPreview, [{
    key: "render",
    value: function render() {
      var _this$props$settings = this.props.settings,
          logoUrl = _this$props$settings.logoUrl,
          primaryColor = _this$props$settings.primaryColor,
          secondaryColor = _this$props$settings.secondaryColor,
          domain = _this$props$settings.domain;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.previewWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.browserBar
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.redBtn, " ").concat(styles.btn)
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.yellowBtn, " ").concat(styles.btn)
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.greenBtn, " ").concat(styles.btn)
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.urlBar
      }, "https://".concat(domain))), /*#__PURE__*/React.createElement("div", {
        className: styles.topBar
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.logo,
        src: logoUrl
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.contentWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.leftNav
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-lightbulb-outline ".concat(styles.leftNavItem),
        style: {
          color: primaryColor
        }
      }), /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-calendar-outline ".concat(styles.leftNavItem)
      }), /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-chatbubble-outline ".concat(styles.leftNavItem)
      }), /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-gear-outline ".concat(styles.leftNavItem)
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.contentArea
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.pageHeader,
        style: {
          color: primaryColor
        }
      }, "Content Library"), /*#__PURE__*/React.createElement("div", {
        className: styles.buttonBar
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.buttonBarButton,
        style: {
          background: secondaryColor,
          color: 'white'
        }
      }, "All"), /*#__PURE__*/React.createElement("span", {
        className: styles.buttonBarButton
      }, "Subscribed")), /*#__PURE__*/React.createElement("div", {
        className: styles.image
      }))));
    }
  }]);

  return WhiteLabelPreview;
}(Component);

export default WhiteLabelPreview;